import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.5.1_@types+node@18.19.85_bufferutil@4.0.9_db0@0.3.1_eslin_90928d83ea08b43bfc813cc16d010b02/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/app/apps/explorer/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}